import { fetchSavedBuildings, savedBuildingsPageLoaded } from './building';
import actions from '..';

const loadSavedBuildingsPage = () => async dispatch => {
  await dispatch(actions.setSavedBuildingsPage());
  dispatch(fetchSavedBuildings());
  dispatch(savedBuildingsPageLoaded());
};

export default loadSavedBuildingsPage;
